/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![MobilePhoneShareIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABVUlEQVR4nM2VS0rEQBCGA4puXKq4dOEpRMk2SKqrsiiqAh7CnRcYmPEOHsITiKgbF6IieINR1+pOMFIzkyHqmHQePhqKhubv/6uubrqC4C8GMy84kgNAuXekWUm8AvBGbYAjHVQYZ470DVD3TB9F0WIYhvPeACAZmgmibFZpzXykR72M43TZ9wSjLH20zDxn5uM9cuMFqQOwETGvONRb2wOodzvMa0FbQJLsrgJqD0iuHMlL8X4A5aIVwCXCQPr07QNAPW8McImwvaCJ0VFMaYgo63mJbLaSNQIkVpZJ5oCyP9WjnHiblwEAtZdn/kl/CKTHXuZlAId6betWFi+jBid4tnVmXvoRgEM5A9LTr3p5dKgPrQFd6X8PEFO6VaVFlO3GgLrxvwFY6A1WulaAvOEUo3gfxbpPf1CSYdctM/v4RWvfGzBu+jqYdZJZmZvW9ngDuhzvxQZwhEeJ9awAAAAASUVORK5CYII=)
 */
export const MobilePhoneShareIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M8 1a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-6.46c0-.35-.34-.6-.69-.56-.2.03-.41.03-.62 0-.35-.03-.69.21-.69.56V16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6.82c.2 0 .4-.14.49-.33a3 3 0 0 1 .8-1c.27-.22.23-.67-.11-.67H8Zm3 18a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M22 7a1 1 0 0 0-.3-.7l-3-3a1 1 0 1 0-1.4 1.4L18.58 6H18a7 7 0 0 0-7 7 1 1 0 1 0 2 0 5 5 0 0 1 5-5h.59l-1.3 1.3a1 1 0 0 0 1.42 1.4l3-3A1 1 0 0 0 22 7Z"
        className={colorClass}
      />
    </svg>
  );
};
